import React from 'react';
import {Link} from "react-router-dom";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import useObjectToGETUrl from "v4/hooks/useObjectToGETUrl";

export default function DashboardTasksSummaryCell({value, preSearch, ...props}) {
    const { getRouteByNativeIdentifier } = useNavigation();
    const tasksRoute = getRouteByNativeIdentifier('main_tasks');
    const {pathname, search} = useObjectToGETUrl(`/${tasksRoute?.url}`, preSearch);

    if (!value || parseFloat(value) <= 0) {
        return <td {...props}>-</td>
    }

    if (preSearch) {
        return (
            <td {...props}>
                <Link to={{pathname, search}}>
                    {value}
                </Link>
            </td>
        )
    }

    return <td {...props}>{value}</td>
}
